import { Icon, Input, Text, VStack } from '@genial/components';
import { Color, Typography } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';
import {
  ActivityIndicator,
  NativeSyntheticEvent,
  TextInputChangeEventData,
  View,
} from 'react-native';

import { CustomerGlobalSearchResponseNormalized } from '../../../../../../../store/customer/types';

interface CustomerSearchItemProps {
  searchTerm: string;
  selectedCustomer?: CustomerGlobalSearchResponseNormalized;
  loading?: boolean;
  customError?: string;
  onSearchTermChange: (value: string) => void;
  onClearSearch: () => void;
}

export const CustomerSearchItem: React.FC<CustomerSearchItemProps> = ({
  searchTerm,
  selectedCustomer,
  loading = false,
  customError,
  onSearchTermChange,
  onClearSearch,
}) => {
  const handleInputChange = (event: NativeSyntheticEvent<TextInputChangeEventData>) => {
    onSearchTermChange(event.nativeEvent.text);
  };

  return (
    <VStack space="stack.nano">
      <Text variant="semibold" color="neutral.darkest">
        Selecione o cliente
      </Text>
      <Input
        hasShadow={false}
        fontSize="md"
        autoComplete="off"
        name="fixed-fee-customer-search"
        variant="filled"
        value={searchTerm}
        onChange={handleInputChange}
        placeholder="Nome, sobrenome, conta, CPF/CNPJ ou Email."
        error={customError ? { message: customError } : undefined}
        customInputProps={{ fontFamily: Typography['fontfamily.base.regular'] }}
        inputRightElement={
          loading ? (
            <View style={{ paddingRight: 16 }}>
              <ActivityIndicator color={Color['brand.tertiary.light']} />
            </View>
          ) : (
            <Pressable onPress={onClearSearch} pr={4}>
              <Icon
                name={selectedCustomer || searchTerm ? 'Close' : 'Search'}
                size="xxxs"
                color="neutral.dark"
              />
            </Pressable>
          )
        }
      />
    </VStack>
  );
};
